// extracted by css-extract-rspack-plugin
export default {"cls1":"CourseResults-cls1_Vt7","cls2":"CourseResults-cls2_EuV CourseResults-cls1_Vt7"};